import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

import bannerOrange from 'assets/images/accommodation/banerOrange.svg'
import bannerBlue from 'assets/images/accommodation/banerBlue.svg'

export const StyledTop = styled(Box)`
    position: relative;
`

interface GuestsBadgeProps {
    isPremium?: boolean
}

export const StyledGuestsBadge = styled(Box)<GuestsBadgeProps>`
    position: absolute;
    top: -46px;
    right: -8px;
    padding-left: 6px;
    padding-bottom: 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 73px;
    height: 82px;
    background: ${(props) =>
        props.isPremium ? `url(${bannerOrange})` : `url(${bannerBlue})`};

    @media ${respondAbove.xl} {
        right: -13px;
    }

    strong {
        display: block;
        line-height: 20px;
    }
`

export const StyledBadge = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_100};
    border-radius: 0 0 8px 8px;
`

export const StyledTrigger = styled(Box)`
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.colors.primary_500};
        border-radius: 4px;
    }
`

export const StyledColumns = styled.div`
    display: block;
    width: 100%;
    columns: 1 100%;

    @media ${respondAbove.md} {
        columns: 2 auto;
        column-gap: 24px;
    }

    & > * {
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }

        @media ${respondAbove.xl} {
            &:last-child {
                margin-bottom: 16px;
            }
        }
    }
`
